import provinces from "@assets/jsons/provinces.json";
import pcbs from "@assets/jsons/site-pcb.json";
import { SingleAutocompleteChoiceType } from "@saleor/components/SingleAutocompleteSelectField";
import { maybe } from "@saleor/misc";
import difference from "lodash-es/difference";

import { StaffDetailsFormData } from "./components/StaffDetailsPage";
import { StaffMemberDetails_user } from "./types/StaffMemberDetails";
/**
 * Return lists of groups which have to be added and removed from user.
 */

interface Node {
  id: string;
  name?: string;
  legalName?: string;
  storeName?: string;
  code?: string;
}

export const groupsDiff = (
  user: StaffMemberDetails_user,
  formData: StaffDetailsFormData
) => {
  const newGroups = formData.permissionGroups;
  const oldGroups = user.permissionGroups.map(u => u.id);

  return {
    addGroups: difference(newGroups, oldGroups),
    removeGroups: difference(oldGroups, newGroups)
  };
};

export function getMallChoices(nodes: Node[]): SingleAutocompleteChoiceType[] {
  return maybe(
    () =>
      nodes.map(node => ({
        label: node.name,
        value: node.id
      })),
    []
  );
}

export function getBrandChoices(nodes: Node[]): SingleAutocompleteChoiceType[] {
  return maybe(
    () =>
      nodes.map(node => ({
        label: node.name + " - " + node.legalName,
        value: node.id
      })),
    []
  );
}

export function getTenantChoices(
  nodes: Node[]
): SingleAutocompleteChoiceType[] {
  return maybe(
    () =>
      nodes.map(node => ({
        label: node.storeName,
        value: node.id
      })),
    []
  );
}

export function getProvinceChoices(): SingleAutocompleteChoiceType[] {
  return maybe(
    () =>
      provinces.provinces.map(node => ({
        label: node.name,
        value: node.code
      })),
    []
  );
}

export function getCityChoices(provinceCode): SingleAutocompleteChoiceType[] {
  return maybe(
    () =>
      pcbs.provinces
        .filter(province => province.code === provinceCode)
        .find(province => province.cities)
        .cities.map(node => ({
          label: node.name,
          value: node.name
        })),
    []
  );
}
